(function () {
    'use strict';
    var msg = typeof pikulinpw_temp_mail !== 'undefined' ? pikulinpw_temp_mail.messages : {};
    var gate = createRequestGate();
    var mutationPending = false;
    var dialog;
    var dialogTrigger;
    var analyticsAddress = '';
    var nonceRefreshPromise = null;
    var reportedErrors = new Set();

    var analyticsEvents = {
        temp_mail_address_ready: {trigger: ['initial', 'change', 'delete']},
        temp_mail_copy: {trigger: ['user']},
        temp_mail_manual_refresh: {trigger: ['user']},
        temp_mail_message_received: {trigger: ['automatic', 'user']},
        temp_mail_message_open: {trigger: ['user']},
        temp_mail_address_change: {trigger: ['user']},
        temp_mail_address_delete: {trigger: ['user']},
        temp_mail_error: {
            trigger: ['initial', 'automatic', 'user'],
            error_stage: ['address_ready', 'copy', 'inbox_refresh', 'message_open', 'address_change', 'address_delete'],
            error_type: ['network', 'timeout', 'unauthorized', 'session_expired', 'not_found', 'service_unavailable', 'invalid_response', 'unknown']
        }
    };
    var analyticsPageTypes = ['home_tool', 'service_guide', 'guide_article', 'blog_article', 'guides_hub', 'blog_hub', 'trust', 'legal', 'archive', 'search', 'error_404', 'other'];

    function analyticsPageType() {
        var value = window.tempMailAnalytics && window.tempMailAnalytics.page_type;
        return analyticsPageTypes.indexOf(value) === -1 ? 'other' : value;
    }
    function sanitizeAnalyticsEvent(name, parameters) {
        var contract = analyticsEvents[name];
        if (!contract) return null;
        var safe = {page_type: analyticsPageType()};
        parameters = parameters || {};
        var keys = Object.keys(parameters);
        if (keys.some(function (key) { return !contract[key]; })) return null;
        var required = Object.keys(contract);
        if (required.some(function (key) { return contract[key].indexOf(parameters[key]) === -1; })) return null;
        required.forEach(function (key) { safe[key] = parameters[key]; });
        return safe;
    }
    function track(name, parameters) {
        var safe = sanitizeAnalyticsEvent(name, parameters);
        if (safe && typeof window.gtag === 'function') window.gtag('event', name, safe);
    }
    function errorTypeFromStatus(status, invalidResponse) {
        if (invalidResponse) return 'invalid_response';
        if (status === 401) return 'unauthorized';
        if (status === 403) return 'session_expired';
        if (status === 404) return 'not_found';
        if (status === 408) return 'timeout';
        if (status >= 500) return 'service_unavailable';
        if (status === 0) return 'network';
        return 'unknown';
    }
    function safeError(status, invalidResponse) {
        var error = new Error(status === 404 ? msg.not_found : status === 403 ? msg.session_expired : msg.unavailable);
        error.tempMailType = errorTypeFromStatus(status, invalidResponse);
        return error;
    }
    function refreshNonce() {
        if (nonceRefreshPromise) return nonceRefreshPromise;
        nonceRefreshPromise = fetch(pikulinpw_temp_mail.ajax_url, {
            method: 'POST', credentials: 'same-origin',
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
            body: new URLSearchParams({action: 'pikulinpw_temp_mail_nonce'}).toString()
        }).then(function (response) {
            return response.json().then(function (data) {
                if (!response.ok || !data.success || !data.data || typeof data.data.nonce !== 'string' || !data.data.nonce) throw safeError(response.status, true);
                pikulinpw_temp_mail.nonce = data.data.nonce;
            });
        }).finally(function () { nonceRefreshPromise = null; });
        return nonceRefreshPromise;
    }
    function initRequest() {
        return fetch(pikulinpw_temp_mail.bootstrap_url, {
            method: 'POST', credentials: 'same-origin', cache: 'no-store',
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Cache-Control': 'no-store'}
        }).then(function (response) {
            return response.text().then(function (responseBody) {
                var data;
                try { data = JSON.parse(responseBody); } catch (error) { throw safeError(response.status, true); }
                if (!response.ok || !data.success || !data.data || typeof data.data.email !== 'string' || !data.data.email) throw safeError(response.status, true);
                return {email: data.data.email, html: '', inbox_error: false, message: ''};
            });
        }).catch(function (error) {
            if (error && error.tempMailType) throw error;
            throw safeError(0);
        });
    }
    function request(action, parameters, signal, retriedAfterNonceRefresh) {
        var body = {action: action, nonce: pikulinpw_temp_mail.nonce};
        Object.keys(parameters || {}).forEach(function (key) { body[key] = parameters[key]; });
        return fetch(pikulinpw_temp_mail.ajax_url, {
            method: 'POST', credentials: 'same-origin',
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
            body: new URLSearchParams(body).toString(), signal: signal
        }).then(function (response) {
            return response.text().then(function (responseBody) {
                var data;
                try { data = JSON.parse(responseBody); } catch (error) { throw safeError(response.status, true); }
                if (!response.ok || !data.success) {
                    if (response.status === 403 && !retriedAfterNonceRefresh) return refreshNonce().then(function () { return request(action, parameters, signal, true); });
                    throw safeError(response.status);
                }
                if (data.data && typeof data.data.nonce === 'string' && data.data.nonce) pikulinpw_temp_mail.nonce = data.data.nonce;
                return data.data || {};
            });
        }).catch(function (error) {
            if (error && error.name === 'AbortError') { error.tempMailAborted = true; throw error; }
            if (error && error.tempMailType) throw error;
            throw safeError(0);
        });
    }
    function createRequestGate() {
        var generation = 0;
        var active = [];
        return {
            begin: function () {
                var controller = window.AbortController ? new window.AbortController() : null;
                var ticket = {generation: generation, controller: controller};
                active.push(ticket);
                return ticket;
            },
            current: function (ticket) { return ticket.generation === generation; },
            release: function (ticket) { active = active.filter(function (item) { return item !== ticket; }); },
            invalidate: function () {
                generation += 1;
                active.forEach(function (ticket) { if (ticket.controller) ticket.controller.abort(); });
                active = [];
            },
            generation: function () { return generation; }
        };
    }
    function parseMessageUrl(href, origin) {
        var url;
        try { url = new URL(href, origin); } catch (error) { return 0; }
        if (url.origin !== origin) return 0;
        var value = url.searchParams.get('tm') || '';
        return /^[1-9][0-9]*$/.test(value) ? Number(value) : 0;
    }
    function canonicalUrl() {
        var url = new URL(window.location.href);
        url.searchParams.delete('tm');
        return url.pathname + url.search + url.hash;
    }
    function messageIds(list) {
        var ids = [];
        if (!list) return ids;
        list.querySelectorAll('a[href]').forEach(function (link) {
            var id = parseMessageUrl(link.href, window.location.origin);
            if (id) ids.push(String(id));
        });
        return ids;
    }
    function rememberMessages(root, list, trigger) {
        root._tempMailSeenMessages = root._tempMailSeenMessages || new Set();
        messageIds(list).forEach(function (id) {
            if (root._tempMailSeenMessages.has(id)) return;
            root._tempMailSeenMessages.add(id);
            track('temp_mail_message_received', {trigger: trigger});
        });
    }
    var inboxStorageKey = 'pikulinpw_temp_mail_inbox_v1';
    function currentInboxEmail() {
        var field = document.querySelector('.wp-block-pikulinpw-temp-mail-block .field-temp-mail, .email-generation .field-temp-mail');
        var email = field && typeof field.value === 'string' ? field.value.trim().toLowerCase() : '';
        return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email) ? email : '';
    }
    function inboxStorage() {
        try { return window.localStorage || null; } catch (error) { return null; }
    }
    function clearInboxCache() {
        var storage = inboxStorage();
        if (!storage) return;
        try { storage.removeItem(inboxStorageKey); } catch (error) {}
    }
    function readInboxCache(email) {
        var storage = inboxStorage();
        if (!storage || !email) return null;
        try {
            var cache = JSON.parse(storage.getItem(inboxStorageKey) || 'null');
            if (!cache || cache.email !== email || typeof cache.html !== 'string' || !Array.isArray(cache.read)) {
                storage.removeItem(inboxStorageKey);
                return null;
            }
            return cache;
        } catch (error) {
            clearInboxCache();
            return null;
        }
    }
    function applyReadState(root) {
        var list = root && root.querySelector('.email-list');
        if (!list) return;
        var available = new Set(messageIds(list));
        var read = root._tempMailReadMessages || new Set();
        root._tempMailReadMessages = new Set(Array.from(read).filter(function (id) { return available.has(id); }));
        list.querySelectorAll('a[href]').forEach(function (link) {
            var id = String(parseMessageUrl(link.href, window.location.origin));
            var item = link.closest('li');
            if (item) item.classList.toggle('is-read', root._tempMailReadMessages.has(id));
        });
    }
    function saveInboxCache(root) {
        var storage = inboxStorage();
        var email = currentInboxEmail();
        var list = root && root.querySelector('.email-list');
        if (!storage || !email || !list) return;
        try {
            storage.setItem(inboxStorageKey, JSON.stringify({email: email, html: list.innerHTML, read: Array.from(root._tempMailReadMessages || new Set())}));
        } catch (error) {}
    }
    function markMessageRead(root, messageId) {
        if (!root || !messageId) return;
        root._tempMailReadMessages = root._tempMailReadMessages || new Set();
        root._tempMailReadMessages.add(String(messageId));
        applyReadState(root);
        saveInboxCache(root);
    }
    function rememberAddress(root, trigger) {
        var field = root && root.querySelector('.field-temp-mail');
        if (!field || !field.value || field.value === analyticsAddress) return;
        analyticsAddress = field.value;
        track('temp_mail_address_ready', {trigger: trigger});
    }
    function resetErrorDedupe(stage, trigger) {
        Array.from(reportedErrors).forEach(function (key) {
            if (key.indexOf(stage + '|' + trigger + '|') === 0) reportedErrors.delete(key);
        });
    }
    function trackError(stage, type, trigger) {
        var key = stage + '|' + trigger + '|' + type;
        if (reportedErrors.has(key)) return;
        reportedErrors.add(key);
        track('temp_mail_error', {trigger: trigger, error_stage: stage, error_type: type});
    }
    function setStatus(root, state, text) {
        if (!root) return;
        ensurePrivateMasking(root);
        root.dataset.state = state;
        var live = root.querySelector('[data-inbox-status]');
        if (live && text) live.textContent = text;
    }
    function announceAddress(text) {
        document.querySelectorAll('[data-address-status]').forEach(function (live) { live.textContent = text; });
    }
    function setEmptyState(root, title, description) {
        var empty = root && root.querySelector('.inbox-empty');
        if (!empty) return;
        ensurePrivateMasking(root);
        var titleNode = empty.querySelector('.inbox-empty__title');
        var descriptionNode = empty.querySelector('.inbox-empty__description');
        if (titleNode) titleNode.textContent = title;
        if (descriptionNode) descriptionNode.textContent = description || '';
    }
    function ensurePrivateMasking(root) {
        if (!root) return;
        if (typeof root.setAttribute === 'function') root.setAttribute('data-clarity-mask', 'true');
        if (typeof root.querySelectorAll !== 'function') return;
        root.querySelectorAll('[data-inbox-status], .inbox, .inbox-empty, .email-list, .email-list li, .email-list a, .sender, .sender .name, .sender .email, .subject, .email-view, .message, .message-header, .message-subject, .message-body, .message-frame, .inbox-unavailable, [data-temp-mail-recover]').forEach(function (node) { if (typeof node.setAttribute === 'function') node.setAttribute('data-clarity-mask', 'true'); });
    }

    function setSessionRecovery(root, active) {
        var empty = root && root.querySelector('.inbox-empty');
        if (!empty) return;
        var recovery = empty.querySelector('[data-temp-mail-recover]');
        if (!active) {
            if (recovery) recovery.remove();
            return;
        }
        if (!recovery) {
            recovery = document.createElement('button');
            recovery.type = 'button';
            recovery.className = 'temp-mail-recovery';
            recovery.setAttribute('data-temp-mail-recover', '');
            recovery.textContent = msg.reload_page;
            empty.appendChild(recovery);
        }
    }
    function setButton(button, text, iconClass) {
        var label = button && button.querySelector('span');
        var icon = button && button.querySelector('i');
        if (label) label.textContent = text;
        else if (button) button.textContent = text;
        if (icon && iconClass) icon.className = iconClass;
    }
    function ensureAddressStatus(root) {
        if (!root || root.querySelector('[data-address-status]')) return;
        var status = document.createElement('div');
        status.className = 'sr-status';
        status.setAttribute('aria-live', 'polite');
        status.setAttribute('data-address-status', '');
        root.appendChild(status);
    }
    function legacyCopy(field) {
        return new Promise(function (resolve, reject) {
            field.focus(); field.select(); field.setSelectionRange(0, field.value.length);
            try { document.execCommand('copy') ? resolve() : reject(new Error('copy_failed')); }
            catch (error) { reject(error); }
        });
    }
    function resetCopyButton(button) {
        if (!button) return;
        window.clearTimeout(button._tempMailCopyTimer);
        button.classList.remove('is-success', 'is-changing');
        setButton(button, msg.copy, 'tempmailicon-copy');
        button.setAttribute('aria-label', msg.copy_address || msg.copy);
    }
    function copyAddress(button) {
        var root = button && button.closest('.wp-block-pikulinpw-temp-mail-block, .email-generation');
        var field = root && root.querySelector('.field-temp-mail');
        if (!field || mutationPending) return Promise.resolve(false);
        resetErrorDedupe('copy', 'user');
        window.clearTimeout(button._tempMailCopyTimer);
        button.classList.add('is-changing');
        var promise = navigator.clipboard && window.isSecureContext ?
            navigator.clipboard.writeText(field.value).catch(function () { return legacyCopy(field); }) :
            legacyCopy(field);
        return promise.then(function () {
            button.classList.remove('is-changing');
            button.classList.add('is-success');
            setButton(button, msg.copy_success, 'tempmailicon-check');
            button.setAttribute('aria-label', msg.copy_status);
            announceAddress(msg.copy_status);
            button._tempMailCopyTimer = window.setTimeout(function () { resetCopyButton(button); }, 1800);
            track('temp_mail_copy', {trigger: 'user'});
            return true;
        }).catch(function () {
            resetCopyButton(button);
            announceAddress(msg.copy_error);
            trackError('copy', 'unknown', 'user');
            return false;
        });
    }
    function clearSchedule(root) {
        if (!root) return;
        window.clearTimeout(root._tempMailPollTimer);
        window.clearTimeout(root._tempMailInitialPollTimer);
        window.clearInterval(root._tempMailCountdownTimer);
        if (root._tempMailInitialIdle && window.cancelIdleCallback) window.cancelIdleCallback(root._tempMailInitialIdle);
        root._tempMailPollTimer = null;
        root._tempMailInitialPollTimer = null;
        root._tempMailInitialIdle = null;
        root._tempMailCountdownTimer = null;
        root._tempMailNextPollAt = null;
    }
    function pollingAllowed() {
        return !document.hidden && navigator.onLine !== false;
    }
    function pausePolling(root) {
        clearSchedule(root);
        var ticket = root && root._tempMailPollTicket;
        if (ticket && ticket.controller) ticket.controller.abort();
        if (root) root._tempMailPollTicket = null;
    }
    function countdownSeconds(root, now) {
        return root && root._tempMailNextPollAt ? Math.max(0, Math.ceil((root._tempMailNextPollAt - (now || Date.now())) / 1000)) : null;
    }
    function setInboxRefreshDisabled(root, disabled) {
        var control = root && root.querySelector('[data-inbox-refresh]');
        if (control) control.disabled = disabled;
    }

    function setEmptyRefreshDisabled(root, disabled) {
        var empty = root && root.querySelector('.inbox-empty[data-empty-refresh]');
        if (empty) empty.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }

    function updateCountdown(root) {
        var timer = root && root.querySelector('[data-refresh-countdown]');
        if (!timer) return;
        if (root.dataset.loading === 'true' || root.dataset.mutating === 'true') {
            timer.disabled = true;
            timer.textContent = msg.refreshing;
            timer.setAttribute('aria-label', msg.refreshing_status);
            return;
        }
        var seconds = countdownSeconds(root);
        timer.disabled = false;
        if (seconds === null) {
            timer.textContent = msg.refresh_now;
            timer.setAttribute('aria-label', msg.refresh_now);
        } else {
            timer.textContent = msg.refresh_in + ' ' + seconds + 's';
            timer.setAttribute('aria-label', msg.refresh_accessible.replace('%d', String(seconds)));
            timer.title = msg.click_to_refresh;
        }
    }
    function scheduleNext(root) {
        clearSchedule(root);
        if (!root || root.dataset.mutating === 'true' || root._tempMailPollingBlocked || !pollingAllowed()) { updateCountdown(root); return; }
        var interval = Math.max(3000, Number(pikulinpw_temp_mail.poll_interval) || 15000);
        root._tempMailNextPollAt = Date.now() + interval;
        updateCountdown(root);
        root._tempMailCountdownTimer = window.setInterval(function () { updateCountdown(root); }, 250);
        root._tempMailPollTimer = window.setTimeout(function () {
            clearSchedule(root);
            if (pollingAllowed()) refreshInbox(root, false);
        }, interval);
    }
    function scheduleInitialInboxRefresh(root) {
        clearSchedule(root);
        if (!root || root.dataset.mutating === 'true' || root._tempMailPollingBlocked) { updateCountdown(root); return; }
        var run = function () {
            root._tempMailInitialIdle = null;
            if (!pollingAllowed()) { updateCountdown(root); return; }
            refreshInbox(root, false);
        };
        root._tempMailInitialPollTimer = window.setTimeout(function () {
            root._tempMailInitialPollTimer = null;
            if (window.requestIdleCallback) root._tempMailInitialIdle = window.requestIdleCallback(run, {timeout: 1000});
            else run();
        }, 750);
    }
    function setRefreshButtons(active) {
        document.querySelectorAll('.btn-temp-mail-refresh').forEach(function (button) {
            if (!button._tempMailNormalText) {
                var label = button.querySelector('span');
                button._tempMailNormalText = label ? label.textContent : button.textContent;
            }
            button.disabled = active || mutationPending;
            button.classList.toggle('is-refreshing', active);
            setButton(button, active ? msg.refreshing : button._tempMailNormalText, 'tempmailicon-repeat');
        });
    }
    function setMessageLoading(root, active) {
        if (!root) return;
        var inbox = root.querySelector('.inbox');
        root.dataset.messageLoading = active ? 'true' : 'false';
        if (inbox) {
            if (active) inbox.setAttribute('aria-busy', 'true');
            else inbox.removeAttribute('aria-busy');
        }
    }
    function cancelRequests() {
        gate.invalidate();
        document.querySelectorAll('.wp-block-pikulinpw-temp-mail-inbox-block').forEach(function (root) {
            root.dataset.loading = 'false';
            setMessageLoading(root, false);
        });
    }
    function refreshInbox(root, manual, initialFeedback) {
        if (!root || root.dataset.loading === 'true' || mutationPending) return Promise.resolve(false);
        if (!manual && !pollingAllowed()) return Promise.resolve(false);
        if (manual) {
            root._tempMailPollingBlocked = false;
            resetErrorDedupe('inbox_refresh', 'user');
        }
        clearSchedule(root);
        var showButtonFeedback = manual || initialFeedback;
        var ticket = gate.begin();
        root._tempMailPollTicket = ticket;
        var list = root.querySelector('.email-list');
        var empty = root.querySelector('.inbox-empty');
        root.dataset.loading = 'true';
        setInboxRefreshDisabled(root, true);
        setEmptyRefreshDisabled(root, true);
        if (showButtonFeedback) setRefreshButtons(true);
        if (empty && (!list || !list.children.length)) {
            empty.hidden = false;
            setEmptyState(root, msg.refreshing_status, msg.refreshing_description);
        }
        setStatus(root, 'refreshing', msg.refreshing_status);
        updateCountdown(root);
        return request('pikulinpw_temp_mail_inbox', {}, ticket.controller && ticket.controller.signal).then(function (data) {
            if (!gate.current(ticket)) return false;
            if (typeof data.html !== 'string') throw safeError(200, true);
            if (list) list.innerHTML = data.html;
            ensurePrivateMasking(root);
            applyReadState(root);
            saveInboxCache(root);
            rememberMessages(root, list, manual ? 'user' : 'automatic');
            if (empty) empty.hidden = Boolean(data.html);
            if (!data.html) setEmptyState(root, manual ? msg.still_waiting : msg.waiting, manual ? msg.still_waiting_description : msg.waiting_description);
            setStatus(root, data.html ? 'messages' : 'empty', data.html ? msg.updated : msg.waiting_status);
            setSessionRecovery(root, false);
            if (manual) track('temp_mail_manual_refresh', {trigger: 'user'});
            resetErrorDedupe('inbox_refresh', 'automatic');
            resetErrorDedupe('inbox_refresh', 'user');
            return true;
        }).catch(function (error) {
            if (error.tempMailAborted || !gate.current(ticket)) return false;
            if (empty && (!list || !list.children.length)) {
                empty.hidden = false;
                setEmptyState(root, msg.inbox_unavailable, error.message);
            }
            setStatus(root, 'unavailable', error.message);
            trackError('inbox_refresh', error.tempMailType || 'unknown', manual ? 'user' : 'automatic');
            if (error.tempMailType === 'session_expired' || error.tempMailType === 'unauthorized') {
                root._tempMailPollingBlocked = true;
                setSessionRecovery(root, true);
            }
            return false;
        }).finally(function () {
            if (gate.current(ticket)) {
                root.dataset.loading = 'false';
                setInboxRefreshDisabled(root, mutationPending);
                setEmptyRefreshDisabled(root, mutationPending);
                scheduleNext(root);
            }
            if (root._tempMailPollTicket === ticket) root._tempMailPollTicket = null;
            gate.release(ticket);
            if (showButtonFeedback) setRefreshButtons(false);
        });
    }
    function showInbox(root, restoreFocus) {
        if (!root) return;
        var inbox = root.querySelector('.inbox');
        var view = root.querySelector('.email-view');
        if (inbox) inbox.hidden = false;
        if (view) view.hidden = true;
        setStatus(root, 'messages', msg.inbox_shown);
        if (restoreFocus && root._tempMailReturnFocus && document.contains(root._tempMailReturnFocus)) root._tempMailReturnFocus.focus();
    }
    function returnToInbox(root) {
        if (!root) return false;
        cancelRequests();
        history.replaceState({}, '', canonicalUrl());
        showInbox(root, true);
        return true;
    }
    function showMessage(root, messageId, html, returnFocus) {
        var inbox = root.querySelector('.inbox');
        var view = root.querySelector('.email-view');
        var message = view && view.querySelector('.message');
        if (!view || !message) return false;
        markMessageRead(root, messageId);
        disconnectMessageFrames(message);
        message.innerHTML = html;
        ensurePrivateMasking(root);
        message.setAttribute('tabindex', '-1');
        view.dataset.messageId = String(messageId);
        if (inbox) inbox.hidden = true;
        view.hidden = false;
        if (returnFocus) root._tempMailReturnFocus = returnFocus;
        message.focus();
        setStatus(root, 'message', msg.message_opened);
        initializeMessageFrames(message);
        return true;
    }
    function disconnectMessageFrames(container) {
        if (!container) return;
        container.querySelectorAll('.message-frame').forEach(function (frame) {
            if (frame._tempMailResizeObserver) frame._tempMailResizeObserver.disconnect();
            frame._tempMailResizeObserver = null;
        });
    }
    function resizeMessageFrame(frame) {
        if (!frame) return;
        var frameDocument;
        try {
            frameDocument = frame.contentDocument;
        } catch (error) {
            return;
        }
        if (!frameDocument) return;
        var documentElement = frameDocument.documentElement;
        var body = frameDocument.body;
        if (!documentElement || !body) return;
        var height = Math.max(documentElement.scrollHeight, documentElement.offsetHeight, body.scrollHeight, body.offsetHeight, 420);
        frame.style.height = height + 'px';
    }
    function disableDarkColorSchemeRules(frame) {
        var frameDocument;
        try {
            frameDocument = frame.contentDocument;
        } catch (error) {
            return;
        }
        if (!frameDocument || !frameDocument.styleSheets) return;
        var darkScheme = /(?:prefers-color-scheme\s*:\s*dark|not\s*\(\s*prefers-color-scheme\s*:\s*light\s*\))/i;
        var removeRules = function (container) {
            var rules = container.cssRules;
            for (var index = rules.length - 1; index >= 0; index -= 1) {
                var rule = rules[index];
                if (rule.media && darkScheme.test(rule.media.mediaText)) {
                    container.deleteRule(index);
                } else if (rule.cssRules && typeof rule.deleteRule === 'function') {
                    removeRules(rule);
                }
            }
        };
        Array.prototype.forEach.call(frameDocument.styleSheets, function (sheet) {
            try {
                removeRules(sheet);
            } catch (error) {
                // Cross-origin stylesheets cannot be inspected; the document-level light scheme still applies.
            }
        });
    }
    function initializeMessageFrames(container) {
        container.querySelectorAll('.message-frame').forEach(function (frame) {
            var ready = function () {
                try {
                    disableDarkColorSchemeRules(frame);
                    resizeMessageFrame(frame);
                    if (!window.ResizeObserver || !frame.contentDocument) return;
                    if (frame._tempMailResizeObserver) frame._tempMailResizeObserver.disconnect();
                    frame._tempMailResizeObserver = new ResizeObserver(function () { resizeMessageFrame(frame); });
                    frame._tempMailResizeObserver.observe(frame.contentDocument.documentElement);
                    if (frame.contentDocument.body) frame._tempMailResizeObserver.observe(frame.contentDocument.body);
                } catch (error) {
                    if (frame._tempMailResizeObserver) frame._tempMailResizeObserver.disconnect();
                    frame._tempMailResizeObserver = null;
                }
            };
            frame.addEventListener('load', ready, {once: true});
            try {
                if (frame.contentDocument && frame.contentDocument.readyState === 'complete') window.requestAnimationFrame(ready);
            } catch (error) {
                // The fixed-height iframe remains usable when its document is not readable.
            }
        });
    }
    function openMessage(root, messageId, returnFocus, pushHistory, sendAnalytics) {
        if (!root || root.dataset.messageLoading === 'true') return;
        var cached = root._tempMailMessages && root._tempMailMessages[messageId];
        if (cached) {
            var shown = showMessage(root, messageId, cached, returnFocus);
            if (shown && pushHistory) history.pushState({tempMailMessage: true, tempMailMessageId: messageId}, '', canonicalUrl());
            if (shown && sendAnalytics) track('temp_mail_message_open', {trigger: 'user'});
            return;
        }
        cancelRequests();
        var ticket = gate.begin();
        setMessageLoading(root, true);
        setStatus(root, 'loading-message', msg.loading_message);
        request('pikulinpw_temp_mail_message', {message_id: messageId}, ticket.controller && ticket.controller.signal).then(function (data) {
            if (!gate.current(ticket)) return;
            if (typeof data.html !== 'string' || !data.html) throw safeError(200, true);
            root._tempMailMessages = root._tempMailMessages || {};
            root._tempMailMessages[messageId] = data.html;
            if (!showMessage(root, messageId, data.html, returnFocus)) return;
            if (pushHistory) history.pushState({tempMailMessage: true, tempMailMessageId: messageId}, '', canonicalUrl());
            if (sendAnalytics) track('temp_mail_message_open', {trigger: 'user'});
        }).catch(function (error) {
            if (!error.tempMailAborted && gate.current(ticket)) {
                setStatus(root, 'unavailable', error.message);
                trackError('message_open', error.tempMailType || 'unknown', 'user');
            }
        }).finally(function () {
            if (gate.current(ticket)) setMessageLoading(root, false);
            gate.release(ticket);
        });
    }
    function setActionButtons(disabled) {
        document.querySelectorAll('.btn-temp-mail-copy, .btn-temp-mail-refresh, .btn-temp-mail-change, .btn-temp-mail-delete').forEach(function (button) { button.disabled = disabled; });
    }
    function beginMutationUI() {
        document.querySelectorAll('.wp-block-pikulinpw-temp-mail-block, .email-generation').forEach(function (root) {
            var field = root.querySelector('.field-temp-mail');
            root.classList.add('is-mutating');
            if (field) {
                field._tempMailValue = field.value;
                field.value = msg.refreshing_address;
                field.setAttribute('aria-busy', 'true');
            }
        });
        document.querySelectorAll('.wp-block-pikulinpw-temp-mail-inbox-block').forEach(function (root) {
            var empty = root.querySelector('.inbox-empty');
            var title = empty && empty.querySelector('.inbox-empty__title');
            var description = empty && empty.querySelector('.inbox-empty__description');
            clearSchedule(root);
            root._tempMailMutationSnapshot = {emptyHidden: empty ? empty.hidden : true, title: title ? title.textContent : '', description: description ? description.textContent : ''};
            root.dataset.mutating = 'true';
            setInboxRefreshDisabled(root, true);
            setEmptyRefreshDisabled(root, true);
            showInbox(root, false);
            if (empty) empty.hidden = false;
            setEmptyState(root, msg.loading_inbox, msg.loading_inbox_description);
            setStatus(root, 'setting-up', msg.loading_inbox);
            updateCountdown(root);
        });
    }
    function finishMutationUI(email, trigger) {
        document.querySelectorAll('.wp-block-pikulinpw-temp-mail-block, .email-generation').forEach(function (root) {
            var field = root.querySelector('.field-temp-mail');
            root.classList.remove('is-mutating');
            if (field) {
                field.value = email || field._tempMailValue || field.value;
                field.removeAttribute('aria-busy');
                field._tempMailValue = null;
            }
            resetCopyButton(root.querySelector('.btn-temp-mail-copy'));
            rememberAddress(root, trigger);
        });
    }
    function resetAddress(button) {
        if (mutationPending) return;
        mutationPending = true;
        setActionButtons(true);
        cancelRequests();
        beginMutationUI();
        var isDelete = button.matches('.btn-temp-mail-delete');
        var eventName = isDelete ? 'temp_mail_address_delete' : 'temp_mail_address_change';
        var addressTrigger = isDelete ? 'delete' : 'change';
        var errorStage = isDelete ? 'address_delete' : 'address_change';
        resetErrorDedupe(errorStage, 'user');
        request('pikulinpw_temp_mail_reset').then(function (data) {
            if (!data.email) throw safeError(200, true);
            clearInboxCache();
            finishMutationUI(data.email, addressTrigger);
            document.querySelectorAll('.wp-block-pikulinpw-temp-mail-inbox-block').forEach(function (root) {
                var list = root.querySelector('.email-list');
                var message = root.querySelector('.message');
                var empty = root.querySelector('.inbox-empty');
                if (list) list.innerHTML = '';
                if (message) { disconnectMessageFrames(message); message.innerHTML = ''; }
                if (empty) empty.hidden = false;
                root._tempMailMessages = {};
                root._tempMailSeenMessages = new Set();
                root._tempMailReturnFocus = null;
                root._tempMailMutationSnapshot = null;
                root.dataset.mutating = 'false';
                setInboxRefreshDisabled(root, false);
                setEmptyRefreshDisabled(root, false);
                showInbox(root, false);
                setEmptyState(root, msg.waiting, msg.waiting_description);
                setStatus(root, 'empty', msg.waiting_status);
                scheduleNext(root);
            });
            if (parseMessageUrl(window.location.href, window.location.origin)) history.replaceState({}, '', canonicalUrl());
            track(eventName, {trigger: 'user'});
        }).catch(function (error) {
            finishMutationUI('');
            document.querySelectorAll('.wp-block-pikulinpw-temp-mail-inbox-block').forEach(function (root) {
                var snapshot = root._tempMailMutationSnapshot;
                var empty = root.querySelector('.inbox-empty');
                root.dataset.mutating = 'false';
                setInboxRefreshDisabled(root, false);
                setEmptyRefreshDisabled(root, false);
                if (snapshot && empty) {
                    empty.hidden = snapshot.emptyHidden;
                    setEmptyState(root, snapshot.title, snapshot.description);
                }
                root._tempMailMutationSnapshot = null;
                setStatus(root, 'unavailable', error.message);
                scheduleNext(root);
            });
            trackError(errorStage, error.tempMailType || 'unknown', 'user');
        }).finally(function () {
            mutationPending = false;
            setActionButtons(false);
            if (document.contains(button)) button.focus();
        });
    }
    function createDialog() {
        var overlay = document.createElement('div');
        overlay.className = 'temp-mail-dialog';
        overlay.hidden = true;
        overlay.innerHTML = '<div class="temp-mail-dialog__panel" role="dialog" aria-modal="true" aria-labelledby="temp-mail-dialog-title" aria-describedby="temp-mail-dialog-description"><button type="button" class="temp-mail-dialog__close" data-dialog-close aria-label="">×</button><h2 id="temp-mail-dialog-title"></h2><p id="temp-mail-dialog-description"></p><div class="temp-mail-dialog__actions"><button type="button" class="temp-mail-dialog__cancel" data-dialog-close></button><button type="button" class="temp-mail-dialog__confirm"></button></div></div>';
        document.body.appendChild(overlay);
        overlay.querySelector('.temp-mail-dialog__cancel').textContent = msg.cancel;
        overlay.querySelector('.temp-mail-dialog__close').setAttribute('aria-label', msg.close_dialog);
        overlay.addEventListener('click', function (event) {
            if (event.target === overlay || event.target.closest('[data-dialog-close]')) closeDialog(true);
        });
        overlay.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') { event.preventDefault(); closeDialog(true); return; }
            if (event.key !== 'Tab') return;
            var focusable = Array.prototype.slice.call(overlay.querySelectorAll('button:not([disabled])'));
            var first = focusable[0], last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        });
        overlay.querySelector('.temp-mail-dialog__confirm').addEventListener('click', function () {
            var trigger = dialogTrigger;
            closeDialog(false);
            if (trigger) resetAddress(trigger);
        });
        return overlay;
    }
    function initializeDecorationVisibility() {
        var roots = Array.prototype.slice.call(document.querySelectorAll('.wp-block-pikulinpw-temp-mail-inbox-block'));
        function sync(root) {
            root.toggleAttribute('data-decorations-paused', document.hidden || root._tempMailInViewport === false);
        }
        roots.forEach(function (root) {
            root._tempMailInViewport = true;
            sync(root);
        });
        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    entry.target._tempMailInViewport = entry.isIntersecting;
                    sync(entry.target);
                });
            });
            roots.forEach(function (root) { observer.observe(root); });
            window.addEventListener('pagehide', function () { observer.disconnect(); }, {once: true});
        }
        document.addEventListener('visibilitychange', function () { roots.forEach(sync); });
    }
    function lockPageForDialog() {
        var body = document.body;
        if (body.classList.contains('temp-mail-dialog-open')) return;
        var scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        body._tempMailOriginalPaddingRight = body.style.paddingRight;
        if (scrollbarWidth) {
            var currentPadding = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
            body.style.paddingRight = (currentPadding + scrollbarWidth) + 'px';
        }
        body.classList.add('temp-mail-dialog-open');
    }
    function unlockPageAfterDialog() {
        var body = document.body;
        body.classList.remove('temp-mail-dialog-open');
        body.style.paddingRight = body._tempMailOriginalPaddingRight || '';
        body._tempMailOriginalPaddingRight = null;
    }

    function openDialog(button, destructive) {
        if (mutationPending) return;
        dialog = dialog || createDialog();
        dialogTrigger = button;
        dialog.classList.toggle('is-destructive', destructive);
        dialog.querySelector('#temp-mail-dialog-title').textContent = destructive ? msg.delete_title : msg.change_title;
        dialog.querySelector('#temp-mail-dialog-description').textContent = destructive ? msg.delete_description : msg.change_description;
        var confirm = dialog.querySelector('.temp-mail-dialog__confirm');
        confirm.textContent = destructive ? msg.delete_action : msg.change_action;
        lockPageForDialog();
        dialog.hidden = false;
        (destructive ? dialog.querySelector('.temp-mail-dialog__cancel') : confirm).focus();
    }
    function closeDialog(restoreFocus) {
        if (!dialog || dialog.hidden) return;
        dialog.hidden = true;
        unlockPageAfterDialog();
        if (restoreFocus && dialogTrigger && document.contains(dialogTrigger)) dialogTrigger.focus();
        if (restoreFocus) dialogTrigger = null;
    }
    function setAddress(root, email, trigger) {
        var field = root && root.querySelector('.field-temp-mail');
        if (!field) return;
        field.value = email || '';
        field.removeAttribute('aria-busy');
        field.placeholder = '';
        resetCopyButton(root.querySelector('.btn-temp-mail-copy'));
        if (email) rememberAddress(root, trigger);
    }
    function initializeAddress(root) {
        root.setAttribute('data-clarity-mask', 'true');
        ensureAddressStatus(root);
        var field = root.querySelector('.field-temp-mail');
        if (field) {
            field.value = '';
            field.placeholder = msg.loading_address;
            field.setAttribute('aria-busy', 'true');
            field.removeAttribute('role');
            field.setAttribute('aria-label', msg.address_label || 'Your temporary email address');
        }
    }
    function initializeInbox(root, initData, schedulePolling) {
        ensurePrivateMasking(root);
        root._tempMailMessages = {};
        var list = root.querySelector('.email-list');
        var html = initData && typeof initData.html === 'string' ? initData.html : '';
        var cache = readInboxCache(initData && initData.email);
        root._tempMailReadMessages = new Set(cache && Array.isArray(cache.read) ? cache.read : []);
        if (list) list.innerHTML = html;
        applyReadState(root);
        saveInboxCache(root);
        root.dataset.cacheReady = 'true';
        root._tempMailSeenMessages = new Set(messageIds(list));
        var emptyRefresh = root.querySelector('.inbox-empty');
        if (emptyRefresh) {
            emptyRefresh.removeAttribute('role');
            emptyRefresh.removeAttribute('tabindex');
            emptyRefresh.removeAttribute('aria-label');
            emptyRefresh.removeAttribute('aria-disabled');
            emptyRefresh.removeAttribute('data-empty-refresh');
        }
        if (emptyRefresh) {
            emptyRefresh.hidden = Boolean(html);
            if (!html) setEmptyState(root, msg.waiting, msg.waiting_description);
        }
        var countdown = root.querySelector('[data-refresh-countdown]');
        if (countdown && countdown.tagName !== 'BUTTON') {
            countdown.setAttribute('role', 'button');
            countdown.setAttribute('tabindex', '0');
        }
        if (initData && initData.inbox_error) {
            setEmptyState(root, msg.inbox_unavailable, initData.message || msg.unavailable);
            setStatus(root, 'unavailable', initData.message || msg.unavailable);
        } else {
            setStatus(root, html ? 'messages' : 'empty', html ? msg.updated : msg.waiting_status);
        }
        var messageId = parseMessageUrl(window.location.href, window.location.origin);
        if (messageId) openMessage(root, messageId, null, false, false);
        else if (schedulePolling !== false && html) scheduleNext(root);
        else if (schedulePolling !== false) scheduleInitialInboxRefresh(root);
    }
    function initTempMail() {
        setActionButtons(true);
        document.querySelectorAll('.wp-block-pikulinpw-temp-mail-inbox-block').forEach(function (root) {
            root.dataset.cacheReady = 'true';
            var empty = root.querySelector('.inbox-empty');
            if (empty) empty.hidden = false;
            setStatus(root, 'setting-up', msg.loading_inbox);
            setEmptyState(root, msg.loading_inbox, msg.loading_inbox_description);
        });
        return initRequest().then(function (data) {
            document.querySelectorAll('.wp-block-pikulinpw-temp-mail-block, .email-generation').forEach(function (root) { setAddress(root, data.email, 'initial'); });
            document.querySelectorAll('.wp-block-pikulinpw-temp-mail-inbox-block').forEach(function (root) { initializeInbox(root, data, false); });
            return refreshNonce().then(function () {
                setActionButtons(false);
                document.querySelectorAll('.wp-block-pikulinpw-temp-mail-inbox-block').forEach(scheduleInitialInboxRefresh);
            });
        }).catch(function (error) {
            setActionButtons(false);
            document.querySelectorAll('.wp-block-pikulinpw-temp-mail-block, .email-generation').forEach(function (root) {
                var field = root.querySelector('.field-temp-mail');
                if (field) field.removeAttribute('aria-busy');
            });
            document.querySelectorAll('.wp-block-pikulinpw-temp-mail-inbox-block').forEach(function (root) {
                var empty = root.querySelector('.inbox-empty');
                if (empty) empty.hidden = false;
                root.dataset.cacheReady = 'true';
                setEmptyState(root, msg.inbox_unavailable, error.message);
                setStatus(root, 'unavailable', error.message);
                setSessionRecovery(root, true);
            });
            trackError('address_ready', error.tempMailType || 'unknown', 'initial');
        });
    }
    function manualRefresh(root) {
        if (root) return refreshInbox(root, true);
        var manual = true;
        document.querySelectorAll('.wp-block-pikulinpw-temp-mail-inbox-block').forEach(function (inboxRoot) {
            refreshInbox(inboxRoot, manual);
            manual = false;
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.wp-block-pikulinpw-temp-mail-block, .email-generation').forEach(initializeAddress);
        initializeDecorationVisibility();
        if (document.querySelector('.temp-mail-status--error')) trackError('address_ready', 'service_unavailable', 'initial');
        document.addEventListener('click', function (event) {
            var field = event.target.closest('.field-temp-mail');
            if (field) {
                field.select(); field.setSelectionRange(0, field.value.length);
                return;
            }
            var recovery = event.target.closest('[data-temp-mail-recover]');
            if (recovery) {
                event.preventDefault();
                window.location.reload();
                return;
            }
            var emptyRefresh = event.target.closest('.inbox-empty[data-empty-refresh]');
            if (emptyRefresh) {
                var emptyRoot = emptyRefresh.closest('.wp-block-pikulinpw-temp-mail-inbox-block');
                if (emptyRoot && emptyRoot.dataset.loading !== 'true' && emptyRoot.dataset.mutating !== 'true' && !emptyRefresh.hidden) {
                    event.preventDefault();
                    manualRefresh(emptyRoot);
                }
                return;
            }
            var headerRefresh = event.target.closest('[data-inbox-refresh]');
            if (headerRefresh) {
                event.preventDefault();
                manualRefresh(headerRefresh.closest('.wp-block-pikulinpw-temp-mail-inbox-block'));
                return;
            }
            var countdown = event.target.closest('[data-refresh-countdown]');
            if (countdown) { event.preventDefault(); manualRefresh(countdown.closest('.wp-block-pikulinpw-temp-mail-inbox-block')); return; }
            var messageLink = event.target.closest('.email-list a');
            if (messageLink) {
                var messageId = parseMessageUrl(messageLink.href, window.location.origin);
                var inboxRoot = messageLink.closest('.wp-block-pikulinpw-temp-mail-inbox-block');
                if (messageId && inboxRoot) { event.preventDefault(); openMessage(inboxRoot, messageId, messageLink, true, true); }
                return;
            }
            var backLink = event.target.closest('.email-view .view-header a');
            if (backLink) {
                var backRoot = backLink.closest('.wp-block-pikulinpw-temp-mail-inbox-block');
                if (backRoot) { event.preventDefault(); returnToInbox(backRoot); }
                return;
            }
            var button = event.target.closest('button');
            if (!button) return;
            if (button.matches('.btn-temp-mail-copy')) { event.preventDefault(); copyAddress(button); }
            else if (button.matches('.btn-temp-mail-refresh')) { event.preventDefault(); manualRefresh(); }
            else if (button.matches('.btn-temp-mail-change')) { event.preventDefault(); openDialog(button, false); }
            else if (button.matches('.btn-temp-mail-delete')) { event.preventDefault(); openDialog(button, true); }
        });
        document.addEventListener('keydown', function (event) {
            var keyboardRefresh = event.target.closest && event.target.closest('[data-refresh-countdown][role="button"], .inbox-empty[data-empty-refresh]');
            if (keyboardRefresh && keyboardRefresh.getAttribute('aria-disabled') !== 'true' && (event.key === 'Enter' || event.key === ' ')) {
                event.preventDefault();
                manualRefresh(keyboardRefresh.closest('.wp-block-pikulinpw-temp-mail-inbox-block'));
            }
        });
        initTempMail();
        document.addEventListener('visibilitychange', function () {
            document.querySelectorAll('.wp-block-pikulinpw-temp-mail-inbox-block').forEach(function (root) {
                if (document.hidden) { pausePolling(root); return; }
                if (!root._tempMailNextPollAt || root._tempMailNextPollAt <= Date.now()) scheduleInitialInboxRefresh(root);
                else updateCountdown(root);
            });
        });
        window.addEventListener('offline', function () {
            document.querySelectorAll('.wp-block-pikulinpw-temp-mail-inbox-block').forEach(pausePolling);
        });
        window.addEventListener('online', function () {
            if (document.hidden) return;
            document.querySelectorAll('.wp-block-pikulinpw-temp-mail-inbox-block').forEach(scheduleInitialInboxRefresh);
        });
        window.addEventListener('popstate', function () {
            cancelRequests();
            var stateMessageId = history.state && history.state.tempMailMessageId;
            var messageId = /^[1-9][0-9]*$/.test(String(stateMessageId || '')) ?
                Number(stateMessageId) :
                parseMessageUrl(window.location.href, window.location.origin);
            document.querySelectorAll('.wp-block-pikulinpw-temp-mail-inbox-block').forEach(function (root) {
                if (!messageId) showInbox(root, true);
                else if (root._tempMailMessages && root._tempMailMessages[messageId]) showMessage(root, messageId, root._tempMailMessages[messageId], null);
                else openMessage(root, messageId, null, false, false);
            });
        });
    });
    if (window.__TEMP_MAIL_TEST__) window.__tempMailInternals = {createRequestGate: createRequestGate, parseMessageUrl: parseMessageUrl, countdownSeconds: countdownSeconds, sanitizeAnalyticsEvent: sanitizeAnalyticsEvent, errorTypeFromStatus: errorTypeFromStatus, messageIds: messageIds, rememberMessages: rememberMessages, returnToInbox: returnToInbox, readInboxCache: readInboxCache, clearInboxCache: clearInboxCache, ensurePrivateMasking: ensurePrivateMasking};
}());
